module.exports = __webpack_public_path__ + "assets/logo-b007af.svg";